import { type UseQueryResult, useQuery } from 'react-query';
import { BrandingPackageQueryService } from '../../services/wealthlane-identity-services';

const useGetCurrentCompanyBrandingConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean = true
): UseQueryResult<string | undefined, unknown> => {
  const brandingConfig = useQuery(
    ['getCurrentCompanyBrandingConfig'],
    async () => {
      return await handleRequest(
        BrandingPackageQueryService.getApiIdentityApiAppBrandingPackageQueryCurrentCompanyBrandingPackageConfig()
      );
    },
    {
      enabled,
      keepPreviousData: true,
      cacheTime: 1000 * 60 * 5,
    }
  );

  return brandingConfig;
};

export default useGetCurrentCompanyBrandingConfig;
